import BloomreachAssets from '@mediashop/base/pattern/atom/BloomreachAssets';
import classNames from 'classnames';
import Headlines from '@mediashop/base/pattern/atom/Headlines';
import useDeviceType from '@mediashop/app/hooks/useDeviceType';
import { SKIP_RENDER } from '@mediashop/app/constants/semanticConstants';
import { BrXImageVariant } from '@mediashop/base/types/imageVariants';
import { HeroTeaserProps } from './index';
import { LinkOpenInTab } from '@mediashop/base/pattern/atom/LinkOpenInTab';

function HeroTeaser({ className, desktopImage, mobileImage, ctaBox }: HeroTeaserProps): JSX.Element {
    const componentName = 'hero-teaser';
    const deviceType = useDeviceType();
    const isMobile = deviceType === 'mobile';

    const image = isMobile ? mobileImage : desktopImage;
    const showBox = ctaBox.headline || ctaBox.text || (ctaBox.buttonText && ctaBox.buttonLink);

    const callActionButton = (link: string) => {
        window.location.href = link;
    };

    return (
        <div className={classNames(componentName, className)}>
            {image ? (
                <div
                    className={`${componentName}__image-container`}
                    onClick={() => (ctaBox.buttonLink && isMobile ? callActionButton(ctaBox.buttonLink) : undefined)}
                >
                    <BloomreachAssets
                        className={componentName}
                        altText={isMobile && mobileImage?.altText ? mobileImage?.altText : desktopImage.altText!}
                        desktopImage={desktopImage}
                        mobileImage={mobileImage}
                        variant={BrXImageVariant.HeroTeaser}
                    />
                </div>
            ) : (
                SKIP_RENDER
            )}
            {showBox && (
                <div
                    className={`${componentName}__box ${componentName}__box--${ctaBox.boxAlignment}`}
                    style={{
                        background: ctaBox.boxBackgroundColor ? ctaBox.boxBackgroundColor : undefined,
                    }}
                >
                    {(ctaBox.headline || ctaBox.text) && (
                        <Headlines
                            textStyle="normalCase"
                            headlineStyle="h3"
                            headline={ctaBox.headline}
                            subheadline={ctaBox.text}
                            textColor={ctaBox.headlineColor}
                            subTextColor={ctaBox.subheadlineColor}
                        />
                    )}
                    {ctaBox.buttonText && ctaBox.buttonLink ? (
                        <LinkOpenInTab
                            link={ctaBox.buttonLink}
                            tab="sameTab"
                            className={`${componentName}__button`}
                            fontColorHex={ctaBox.ctaFontColor}
                            backgroundColorHex={ctaBox.ctaBackgroundColor}
                        >
                            {ctaBox.buttonText}
                        </LinkOpenInTab>
                    ) : (
                        SKIP_RENDER
                    )}
                </div>
            )}
        </div>
    );
}

export default HeroTeaser;
